import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import qs from 'querystring';
import { t } from 'utils/translates';

import {
  selectItemById,
  dataRequest
} from 'mt-react-common/common/reducers/objectCollection/reducer';
import MediumPreLoader from 'components/Common/PreLoaders/MediumPreLoader';
import ListItemLink from 'components/Common/ListItemLink/ListItemLink';

const faqContentCollectionRN = 'faqContents.collections.faqContentCollection';

class ContentView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      searchValue: ''
    };
    if (!this.props.selectItem) {
      this.props.dataRequest();
    }
  }

  componentDidUpdate(prevProp) {
    if (this.props.match.params.seoUrl !== prevProp.match.params.seoUrl) {
      if (!this.props.selectItem) {
        this.props.dataRequest();
      }
    }
  }

  handleSubmit = event => {
    event.preventDefault();
    if (this.state.searchValue.length > 0) {
      this.context.router.history.push({
        pathname: '/help/reference-information/search',
        search: `?${qs.stringify({ content: this.state.searchValue })}`
      });
    }
  };

  render() {
    if (!this.props.selectItem) {
      return <MediumPreLoader />;
    }
    return (
      <React.Fragment>
        <div className="row">
          <div className="col-xs-24">
            <form className="form-inline" onSubmit={this.handleSubmit}>
              <div className="form-group pull-right m-b-0 visible-sm">
                <button
                  className="btn btn-default"
                  data-toggle="sidebar-r"
                  type="button"
                >
                  <span>{t('Меню')}</span>
                </button>
              </div>
              <div className="form-group pull-right">
                <label className="sr-only control-label" htmlFor="helpSearch">
                  {t('Поиск по справке')}
                </label>
                <div className="input-group">
                  <input
                    className="form-control ng-untouched ng-pristine ng-valid"
                    id="helpSearch"
                    name="helpSearch"
                    placeholder="Поиск по справке"
                    type="text"
                    value={this.state.searchValue}
                    onChange={e => {
                      this.setState({
                        searchValue: e.target.value
                      });
                    }}
                  />
                  <span className="input-group-btn">
                    <button
                      className="btn btn-default text-overflow_no"
                      type="submit"
                    >
                      <i className="fa fa-search" />
                    </button>
                  </span>
                </div>
              </div>
              <div className="form-group form-group-block">
                <div className="form-control-static">
                  <ol className="breadcrumb">
                    <ListItemLink to={`/help/reference-information`}>
                      {t('Справка')}{' '}
                    </ListItemLink>
                    {this.props.selectItem.parent ? (
                      <ListItemLink
                        to={`/help/reference-information/view/${this.props.selectItem.parent.seoUrl}`}
                      >
                        {this.props.selectItem.parent.title}{' '}
                      </ListItemLink>
                    ) : null}
                    <ListItemLink
                      to={`/help/reference-information/view/${this.props.selectItem.seoUrl}`}
                    >
                      {this.props.selectItem.title}{' '}
                    </ListItemLink>
                  </ol>
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-xs-24">
            <div className="panel panel-default">
              <div className="panel-body">
                <div className="paper">
                  <header>
                    <h1>{this.props.selectItem.title}</h1>
                  </header>
                  <div
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML={{
                      __html: this.props.selectItem.html
                    }}
                  />
                </div>
                <div className="paper-list">
                  {this.props.selectItem.children.map(child => (
                    <article key={`contentViewChildren${child.id}`}>
                      <h3>
                        <Link
                          to={`/help/reference-information/view/${child.seoUrl}`}
                        >
                          {child.title}
                        </Link>
                      </h3>
                    </article>
                  ))}
                </div>
              </div>
            </div>
            <nav>
              <ul className="pager pager_squared">
                <li className="previous">
                  {this.props.selectItem.beforeContentSeoUrl ? (
                    <Link
                      to={`/help/reference-information/view/${this.props.selectItem.beforeContentSeoUrl.seoUrl}`}
                    >
                      <span aria-hidden="true">←</span>{' '}
                      {this.props.selectItem.beforeContentSeoUrl.title}
                    </Link>
                  ) : null}
                </li>
                <li className="next">
                  {this.props.selectItem.nextContentSeoUrl ? (
                    <Link
                      to={`/help/reference-information/view/${this.props.selectItem.nextContentSeoUrl.seoUrl}`}
                    >
                      <a href="">
                        {this.props.selectItem.nextContentSeoUrl.title}{' '}
                        <span aria-hidden="true">→</span>
                      </a>
                    </Link>
                  ) : null}
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

ContentView.contextTypes = {
  router: PropTypes.shape()
};

ContentView.defaultProps = {
  selectItem: null
};

ContentView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      seoUrl: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,

  selectItem: PropTypes.shape({
    title: PropTypes.string.isRequired,
    seoUrl: PropTypes.string.isRequired,
    html: PropTypes.string.isRequired,
    children: PropTypes.arrayOf(PropTypes.shape),
    beforeContentSeoUrl: PropTypes.shape({
      title: PropTypes.string.isRequired,
      seoUrl: PropTypes.string.isRequired
    }),
    nextContentSeoUrl: PropTypes.shape({
      title: PropTypes.string.isRequired,
      seoUrl: PropTypes.string.isRequired
    }),
    parent: PropTypes.shape({
      title: PropTypes.string,
      seoUrl: PropTypes.string
    })
  }),
  dataRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  selectItem: selectItemById(
    state,
    faqContentCollectionRN,
    props.match.params.seoUrl
  )
});

const mapDispatchToProps = (dispatch, props) => ({
  dataRequest: () =>
    dispatch(dataRequest(faqContentCollectionRN, props.match.params.seoUrl))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContentView);



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Help/ReferenceInformation/ContentView/ContentView.js